var TEMPLATE_URL = require('./share.url.html');
angular.module('ikeweb.spike.sharing').directive('shareUrl', ['events',

    function(EVENTS) {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                url: '@'
            },
            link: function($scope) {
                $scope.displayEvent = EVENTS.SHARING.DISPLAY_SHARE_URL;
                $scope.dismissEvent = EVENTS.SHARING.DISMISS_SHARE_URL;
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/sharing/share-url/share.url.directive.js
// module id = 594
// module chunks = 0